/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

/**
 * @fileoverview Locale mapping utility
 * Provides functions to map short locale codes to full locale formats
 * Used throughout the application for internationalization purposes
 * @module utils/locale
 */

/**
 * Maps a short locale code to its corresponding full locale format
 * Used for internationalization and localization throughout the application
 *
 * @function
 * @param {string} locale - Short locale code (e.g., 'en', 'ko', 'zh')
 * @returns {string} Full locale format (e.g., 'en-GB', 'ko-KR', 'zh-CN')
 * @default 'en-GB' if the provided locale is not supported
 */
export function getLocale(locale) {
  return (
    {
      de: "de-DE", // German (Germany)
      en: "en-GB", // English (United Kingdom)
      es: "es-ES", // Spanish (Spain)
      fr: "fr-FR", // French (France)
      hi: "hi-IN", // Hindi (India)
      id: "in-ID", // Indonesian (Indonesia)
      ja: "ja-JP", // Japanese (Japan)
      km: "km-KH", // Khmer (Cambodia)
      ko: "ko-KR", // Korean (South Korea)
      ms: "ms-MY", // Malay (Malaysia)
      pt: "pt-PT", // Portuguese (Portugal)
      ru: "ru-RU", // Russian (Russia)
      te: "te-IN", // Telugu (India)
      th: "th-TH", // Thai (Thailand)
      vi: "vi-VN", // Vietnamese (Vietnam)
      zh: "zh-CN", // Chinese (China)
    }[locale] ?? "en-GB"
  );
}
